export default {
    OrdinaryOrderMix: {
        LogiTab: {
            Parcel: '包裹号',
            Company: '物流公司',
            Tracking: '物流单号',
            Type: '物流业务类型',
            Time: '包裹号获取时间',
            updateTime: '轨迹最新更新时间',
            trackingStatus: '最新轨迹',
            Status: '状态',
            Delivered: '已签收',
            InTransit: '运输中',
            NoRecord: '无记录',
            Freight: '运费',
        },
        EditReceiverInfo: {
            name: '收货人姓名',
            phone: '收货人手机号',
            address: '收货地址',
            Detailed: '详细地址',
            receipt: '修改收货信息',
            select: '请选择省/市/区',
            enter: '请输入详细地址',
            the: '请输入收货人姓名',
            mobile: '请输入收货人手机号',
        },
        EditRemarks: {
            Modify: '修改',
            buyer: '请输入 买家备注',
            merchant: '请输入 商家备注',
            customer: '请输入 客服备注',
            comment: '买家备注',
            Comments: '商家备注',
            service: '客服备注',
        },
        GoodsInfoTab: {
            // 1
            Confirm: '确认收货',
            Pending: '挂起',
            Unhook: '解挂',
            Summarize: '按商品汇总',
            product: '按商品行明细',
            suspend: '是否确认挂起？',
            cancel: '是否确认解挂？',
            goods: '是否确认收货？',
            black: '设置黑白名单',
            // 2 //3
            Receiving: '收货状态',
            Shipment: '发货状态',
            occupied: '预占状态',
            Sourcing: '寻源状态',
            status: '挂起状态',
            Write: '预占回写状态',
            update: '发货回写状态',
            Label: '标签',
            // name: '商品名称',
            // code: '商品编码',
            SKU: 'SKU编码',
            Giveaway: '是否赠品',
            Quantity: '数量',
            platform: '三方平台销售单价',
            total: '三方平台均摊总价',
            sales: '内部销售价',
            average: '内部均摊总价',
            Cost: '成本单价',
            Totalf: '成本总价',
            Freight: '运费',
            // 3
            Oo: '套',
            see: '查看',
            back: '返回数据为空，请联系管理员',
            Order: '订单发货',
            ps1: '该订单缺货!',
            ps2: '该订单已审核通过，无需重新发货!',
            ps3: '该订单询价状态异常!',
        },
        LogisticsTable: {
            // 1
            outerOrderNo: '外部单号',
            innerOrderNo: '内部单号',
            logisticsNo: '物流单号',
            TrackingNo: '物流单号',
            ParcelNo: '包裹号 : ',
            TrackingDetails: '物流详情',
            TrackingStatus: '状态',
            TrackingLocation: '地点',
            TrackingTime: '日期/时间',
            logisticsCompany: '物流公司',
            logisticsBusinessName: '物流业务类型',
            totalPrice: '总运费',
            // 2
            Shipment: '运单文件',
            ps1: '请在此仅上传运单文件。（最大 5 MB）',
            ps2: '请使用运单号作为文件名',
            Supporting: '其他相关文件',
            ps3: '请在此上传其他相关文件，如拣货单、装箱单等。（最大 5 MB）',
            Package: '包 裹',
            PriceSearchResults: '询价结果',
            priceReferenceTip: 'API返回价格仅供参考。',
            // 3
            Doc: '单号',
            Delivery: '出库结果单号/出库通知单号',
            Logistics: '物流单号',
            company: '物流公司',
            No: '出库通知单单号',
            of: '包裹商品数',
            time: '出库时间',
            Operation: '操作',
            Details: '包裹明细',
            // 4
            creation: '发货通知单',
            Serial: '序号',
            // name: '商品名称',
            // code: '商品编码',
            SKU: 'SKU编码',
            Quantity: '数量',
            cancel: '取消物流',
            send: '推送至Sap',
        },
        O2oConfirmReceipt: {
            Confirm: '确认收货',
            Upload: '上传凭证',
            Description: '说明',
        },
        OrderItemTable: {
            // Product: '商品名称',
            // code: '商品编码',
            name: 'SKU名称',
            SKU: 'SKU编码',
            SPU: '批次号',
            Quantity: '数量',
            Whether: '是否赠品',
            Sales: '三方平台销售单价',
            Total: '三方平台均摊总价',
            price: '内部销售价',
            Internal: '内部均摊总价',
            unit: '成本单价',
            cost: '成本总价',
            Freight: '运费',
            Operation: '操作',
            Delete: '删 除',
            returned: '返回数据为空，请联系管理员',
        },
        SuspendReason: {
            Please: '请输入',
            Suspend: '挂起原因',
            continue: '您正在解除此订单的挂起状态，是否继续？',
        },
    }
};
